import { render, staticRenderFns } from "./lactationYieldOfAliveCows.vue?vue&type=template&id=c67d995a&scoped=true&"
import script from "./lactationYieldOfAliveCows.vue?vue&type=script&lang=js&"
export * from "./lactationYieldOfAliveCows.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c67d995a",
  null
  
)

export default component.exports